module.exports = __webpack_public_path__ + "img/9936.c5bd3d1d.jpg";